<template>
  <div>
    <el-dialog
      title="成员列表"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1040px"
    >
      <el-table
        :data="members"
        border
        size="small"
        height="600px"
        style="width: 986px"
        @sort-change="changeSort"
      >
        <el-table-column prop="zoneId" label="区服" align="center" width="50">
        </el-table-column>
        <el-table-column prop="uid" label="uid" align="center" width="80">
        </el-table-column>
        <el-table-column prop="name" label="昵称" align="center" width="120">
        </el-table-column>

        <el-table-column label="等级" prop="lv" align="center" width="50">
        </el-table-column>

        <el-table-column label="职位" prop="title" align="center" width="100">
        </el-table-column>

        <el-table-column
          prop="historicalContributedGuildExp"
          label="累计贡献经验"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="isInteractiveForbidden"
          label="在灰名单"
          align="center"
          width="95"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.isInteractiveForbidden" style="">否</span>
            <span v-if="scope.row.isInteractiveForbidden" style="color: red"
              >是</span
            >
          </template>
        </el-table-column>
        <el-table-column label="在线状态" align="center" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.isOnline" style="color: green">在线</span>
            <span v-else>离线</span>
          </template>
        </el-table-column>
        <el-table-column label="上一次活跃时间" align="center" width="140">
          <template slot-scope="scope">
            {{ $util.ms2datetime(scope.row.latestActiveAt) }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button
              type="primary"
              round
              size="mini"
              @click="toRouterPlayerInfoPage(scope.row)"
              >详情</el-button
            >
            <el-button
              type="danger"
              round
              size="mini"
              @click="kickOutGuildMember(scope.row)"
              >踢出</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      visible: true,
      members: [], // 列表里展示的数据
      form: {
        orderBy: "",
        sort: "",
      },
    };
  },

  created() {
    // 拉取集合
    this.loadMembers(this.value.gid);
  },
  props: {
    value: Object,
  },
  components: {},

  methods: {
    /**
     * 拉取集合
     */
    async loadMembers(gid) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/guild/getGuildMembers`,
          {
            gid: gid,
            orderBy: this.form.orderBy,
            sort: this.form.sort,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }
      let listInResponse = resData.data.list || [];

      this.members = listInResponse;
    },

    /**
     * 改变排序规则
     */
    changeSort(e) {
      this.form.orderBy = "";
      this.form.sort = "";
      if (e.order != null) {
        this.form.orderBy = e.prop;
        this.form.sort = e.order;
      }

      this.loadMembers(this.value.gid);
    },

    /**
     * 强制踢出
     * @param {*} entry
     */
    async kickOutGuildMember(entry) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认踢出uid为“${entry.uid}”、昵称为“${entry.name}”的玩家？`
        );

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/guild/kickOutGuildMember`,
            {
              gid: this.value.gid,
              uid: entry.uid,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "踢出成功",
          type: "success",
        });
        for (let i = 0; i < this.members.length; i++) {
          if (this.members[i].uid == entry.uid) {
            this.members.splice(i, 1);
            break;
          }
        }

        if (this.members.length == 0) {
          this.onClosed();
        }
      } catch (e) {}
    },

    /**
     * 跳转到玩家详情界面
     * @param {*} entry
     */
    toRouterPlayerInfoPage(entry) {
      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: { uid: entry.uid, tab: "playerList" },
        }).href,
        "_blank"
      );
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },
    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}

.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

